import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';
import quoteNS from './constants/quoteNS';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, quoteNS)}`
    : '';
  const searchQuotes = `searchQuotes(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchQuotes} {
        id
        type
        status
        reason
        accountId
        userId
        effectiveDate
        submittedDate
        salesAgentId
        clientId
        orderId
        quoteSource
      }
    }
  `;
};
